// Module
var code = "<div class=\"sign-up\"> <div class=\"sign-up__message\" system-dictionary=\"{{ $ctrl.getMessage() }}\"></div> <button type=\"button\" role=\"button\" class=\"jbr-btn jbr-btn--dark\" ng-class=\"{ 'jbr-btn--loading': $ctrl.loading }\" ng-click=\"$ctrl.onSignUp()\" system-dictionary=\"{{ $ctrl.label }}\"></button> </div> ";
// Exports
module.exports = code;